<template>
    <div class="ticimax-member-selector">
        <div class="left">
            <h3>{{ $t("message.filters") }}</h3>
            <div v-for="(group, index) of clone.groups" :key="group.id">
                <FilterGroup
                    :on-removed="onFilterGroupRemoved"
                    v-model="clone.groups[index]"
                    :show-remove-button="clone.groups.length > 1"
                />
                <div
                    class="filter-condition-wrapper"
                    v-if="clone.groups.length > 1 && index !== clone.groups.length - 1"
                >
                    <div class="filter-condition">
                        <a-select
                            :value="clone.operator"
                            @change="(op) => (clone.operator = op)"
                            @click="
                                (e) => {
                                    e.stopPropagation();
                                }
                            "
                            @mouseenter="() => (selectHovered = true)"
                            @mouseleave="() => (selectHovered = false)"
                            :class="{ hovered: selectHovered }"
                        >
                            <a-select-option value="or">{{ $t("chatbotv2.or") }}</a-select-option>
                            <a-select-option value="and"> {{ $t("chatbotv2.and") }}</a-select-option>
                        </a-select>
                    </div>
                </div>
            </div>
            <div class="filter-add-group-wrapper">
                <div class="filter-add-group" @click="addFilterGroup">
                    <div class="filter-add-group-plus">
                        <span class="material-icons"> add </span>
                    </div>
                    <span>{{ $t("chatbotv2.addFilterGroup") }}</span>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="preview-title">
                <h3>{{ $t("ticimax.examplePreview") }}</h3>
                <SupsisButton :primary="true" @click="downloadAsFile" :disabled="downloading">{{ $t("message.excelDownload") }}</SupsisButton>
            </div>
            <div>
                <ve-pagination
                    :total="totalMembers"
                    :page-index="cursor.page"
                    :page-size="cursor.perPage"
                    :page-size-option="[10, 15, 20, 50, 100]"
                    @on-page-number-change="(val) => (cursor.page = val)"
                    @on-page-size-change="(val) => (cursor.perPage = val)"
                />
            </div>
            <MembersTable
                v-model="tableModel"
                :loading="loading"
                :members="members"
                :fullScreen="fullScreen"
                readonly
            />
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import FilterGroup from "./filter/FilterGroup.vue";
import { generateRandomId } from "../../../../../../utils/session";
import _ from "lodash";
import MembersTable from "../MembersTable.vue";
import { TICIMAX_API } from "../../../../../../api/ticimax";
import log2 from "../../../../../../utils/log2";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";

const log = log2("MemberSelector");
export default Vue.extend({
    name: "MemberSelector",
    components: { MembersTable, FilterGroup, SupsisButton },
    props: {
        value: {
            type: Object,
            required: true,
            default: () => ({
                groups: [],
                operator: "or",
            }),
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            filterAddCtx: null,
            selectHovered: false,
            loading: false,
            tableModel: {
                sort: {
                    field: "lastOrderDate",
                    direction: -1,
                },
                filters: {},
                cursor: {
                    page: 1,
                    perPage: 5,
                },
            },
            members: [],
            totalMembers: 0,
            cursor: {
                page: 1,
                perPage: 10,
            },
            fullScreen: false,
            downloading: false,
        };
    },
    methods: {
        fetch() {
            this.loading = true;
            const isEmpty = this.clone.groups.every((group) => group.filters.length === 0);
            if (isEmpty) {
                this.loading = false;
                this.members = [];
                return;
            }
            TICIMAX_API.listExampleMembersByFilterGroups(this.clone, this.cursor)
                .then((res) => {
                    this.members = res.data.data;
                    this.totalMembers = res.data.count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onFilterGroupRemoved(id) {
            this.clone.groups = this.clone.groups.filter((group) => group.id !== id);
        },
        addFilterGroup() {
            const id = generateRandomId();
            this.clone.groups.push({
                id,
                operator: "or",
                filters: [],
            });
        },
        downloadAsFile() {
            this.downloading = true;
            TICIMAX_API.listExampleMembersByFilterGroups(this.clone, {}, true)
                .then((res) => res.data)
                .then((data) => {
                    const { s3Key } = data;
                    const url = data.v2Format && data.cdnUrl
                        ? data.cdnUrl
                        : `https://static.supsis.live/${s3Key}`;
                    window.open(url, "_blank");
                    this.downloading = false;
                });
        },
        /**  switchToFullScreenMode() {
         if (this.fullScreen) {
         this.closeFullScreenMode();
         } else {
         const elem = document.querySelector(".members-table");
         fscreen.requestFullscreen(elem);
         this.fullScreen = true;
         }
         },
         closeFullScreenMode() {
         fscreen.exitFullscreen();
         this.fullScreen = false;
         },**/
    },
    mounted() {
        log("mounted", this.value);
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.fetch();
                this.$emit("input", newValue);
            },
        },
        cursor: {
            handler() {
                this.fetch();
            },
            deep: true,
        },
    },
});
</script>

<style lang="scss">
.ticimax-member-selector {
    display: flex;
    gap: 10px;
    padding: 30px 0 60px;

    .right {
        .preview-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
    .left {
        width: 300px;
        border-right: 1px solid #ccc;
        min-height: 500px;
        padding-right: 10px;
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .right {
        width: calc(100% - 300px);
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .filter-condition-wrapper {
        align-items: center;
        display: flex;
        justify-content: center;
        width: 100%;
        margin-top: 30px;

        &:before {
            border-top: 1px solid #ccc;
            content: "";
            flex-grow: 1;
            height: 0;
            width: 0;
        }

        &:after {
            border-top: 1px solid #ccc;
            content: "";
            flex-grow: 1;
            height: 0;
            width: 0;
        }

        .filter-condition {
            margin: 0px 25px;
            width: 80px;

            .ant-select {
                &.hovered {
                    .ant-select-selection {
                        border-color: #40a9ff !important;
                        border-right-width: 1px !important;
                        background: #40a9ff52 !important;
                    }
                }
            }
        }
    }

    .filter-add-group-wrapper {
        align-items: center;
        display: flex;
        height: 40px;
        justify-content: center;
        width: 100%;

        &:before {
            border-top: 1px solid #ccc;
            content: "";
            flex-grow: 1;
            height: 0;
            width: 0;
        }

        &:after {
            border-top: 1px solid #ccc;
            content: "";
            flex-grow: 1;
            height: 0;
            width: 0;
        }

        .filter-add-group {
            cursor: pointer;
            display: flex;
            margin: 0 10px;
            transition: opacity 0.3s;

            span {
                color: #475e7a;
                font-weight: 600;
            }

            .filter-add-group-plus {
                align-items: center;
                background: #fff;
                border-radius: 100%;
                box-shadow: 0 1px 4px 0 rgb(0 0 0 / 19%);
                display: flex;
                height: 22px;
                justify-content: center;
                margin-right: 10px;
                transition: background-color 0.3s;
                width: 22px;

                &:hover {
                    background: #006cff;
                    color: #fff;

                    .material-icons {
                        color: #fff;
                    }
                }

                .material-icons {
                    color: #006cff;
                    font-size: 12px;
                    margin-left: 1px;
                    transition: color 0.6s;
                }
            }
        }
    }
}
</style>
